import React from 'react'
import { motion } from 'framer-motion'
import { Box, Typography, Grid, Chip, useMediaQuery } from '@material-ui/core'
import TechnologiesHoneycomb from './TechnologiesHoneycomb'

const SkillsSection = ({
  programmingLanguages = [],
  cloudProviders = [],
  subjectMatterExpertise = [],
  technologiesAndFrameworks = {}
}) => {
  const isMobile = useMediaQuery('(max-width: 480px)');
  const isTablet = useMediaQuery('(max-width: 768px)');
  const isSmallDesktop = useMediaQuery('(max-width: 1024px)');
  const skillCategories = [
    { title: 'Programming Languages', items: programmingLanguages || [], color: '#00ffff' },
    { title: 'Cloud Providers', items: cloudProviders || [], color: '#ff00ff' },
    { title: 'Subject Matter Expertise', items: subjectMatterExpertise || [], color: '#00ff88' }
  ]

  return (
    <Box>
      <Grid container spacing={isMobile ? 2 : 4}>
        {skillCategories.map((category, catIndex) => (
          <Grid item xs={12} md={4} key={catIndex}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: catIndex * 0.2 }}
            >
              <Box style={{
                background: 'rgba(0, 0, 0, 0.5)',
                border: `2px solid ${category.color}33`,
                borderRadius: '12px',
                padding: isMobile ? '1.5rem' : '2rem',
                height: '100%',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease'
              }}
                   onMouseEnter={(e) => {
                     e.currentTarget.style.borderColor = category.color
                     e.currentTarget.style.boxShadow = `0 0 30px ${category.color}40`
                   }}
                   onMouseLeave={(e) => {
                     e.currentTarget.style.borderColor = `${category.color}33`
                     e.currentTarget.style.boxShadow = 'none'
                   }}
              >
                <Typography style={{
                  fontFamily: '"Orbitron", monospace',
                  fontSize: isMobile ? '1.2rem' : isTablet ? '1.4rem' : '1.6rem',
                  color: category.color,
                  marginBottom: isMobile ? '1rem' : '1.5rem',
                  textShadow: `0 0 10px ${category.color}80`,
                  fontWeight: 'bold'
                }}>
                  {category.title}
                </Typography>

                <Box style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: isMobile ? '0.5rem' : '0.75rem'
                }}>
                  {category.items.map((skill, index) => (
                    <motion.div
                      key={index}
                      whileHover={{ scale: 1.1, y: -3 }}
                      transition={{ duration: 0.2 }}
                    >
                      <Chip
                        label={skill}
                        style={{
                          background: `rgba(0, 0, 0, 0.7)`,
                          border: `2px solid ${category.color}`,
                          color: '#ffffff',
                          textShadow: `0 0 8px ${category.color}, 0 1px 2px rgba(0,0,0,0.8)`,
                          fontWeight: 'bold',
                          fontFamily: '"Share Tech Mono", monospace',
                          fontSize: isMobile ? '0.9rem' : isTablet ? '1rem' : '1.1rem',
                          padding: isMobile ? '0.6rem 0.8rem' : isTablet ? '0.7rem 1rem' : '0.8rem 1.2rem',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = `${category.color}33`
                          e.currentTarget.style.boxShadow = `0 0 15px ${category.color}40`
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = `${category.color}1A`
                          e.currentTarget.style.boxShadow = 'none'
                        }}
                      />
                    </motion.div>
                  ))}
                </Box>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {technologiesAndFrameworks && Object.keys(technologiesAndFrameworks).length > 0 && (
        <Box style={{ marginTop: isMobile ? '2rem' : '4rem' }}>
          <TechnologiesHoneycomb technologiesAndFrameworks={technologiesAndFrameworks}/>
        </Box>
      )}
    </Box>
  )
}

export default SkillsSection
